import { AppLauncher } from '@capacitor/app-launcher';
import { Browser } from '@capacitor/browser';

import { isCapacitorNative } from '@/core/utils/capacitor.utils';

/**
 * Open a URL in a new tab (web) or the Capacitor in-app browser (native).
 * Prefer for digital profiles and flows that should return to the app easily.
 */
export async function openExternalUrl(url: string): Promise<void> {
  const trimmed = url.trim();
  if (!trimmed) return;

  if (isCapacitorNative()) {
    try {
      await Browser.open({ url: trimmed });
    } catch {
      // Invalid or blocked URLs should not crash the editor.
    }
    return;
  }

  window.open(trimmed, '_blank', 'noopener,noreferrer');
}

/**
 * Open a URL in the OS default browser (Safari/Chrome), not the in-app sheet.
 * Prefer for Google review, Instagram, menus, and other public destinations.
 */
export async function openInSystemBrowser(url: string): Promise<void> {
  const trimmed = url.trim();
  if (!trimmed) return;

  if (isCapacitorNative()) {
    try {
      await AppLauncher.openUrl({ url: trimmed });
    } catch {
      // Invalid or blocked URLs should not crash the caller.
    }
    return;
  }

  window.open(trimmed, '_blank', 'noopener,noreferrer');
}
